import { Input as ChakraInput, type InputProps as ChakraInputProps } from "@chakra-ui/react";

export function Input({
  inputRef,
  ...props
}: { inputRef?: React.Ref<HTMLInputElement> } & ChakraInputProps) {
  return <ChakraInput ref={inputRef} {...props} />;
}

export type InputProps = ChakraInputProps;
